/*
** $Id$
**
** Copyright 2018 Port25 Solutions, Inc.
** All rights reserved.
*/


import React, { Component } from 'react';
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import '../css/togglebutton.css';
import PropTypes from 'prop-types';


/**
 * Helps refresh components automatically.
 */
export default class AutoRefresh extends Component {
    constructor(props) {
        super(props)
        this.toggleAutoRefresh = this.toggleAutoRefresh.bind(this)
        this.isAutoRefreshOn = true
    }


    static propTypes = {
        /**
         * Function to invoke periodically when auto-refresh is turned on.
         */
        refresh: PropTypes.func.isRequired,

        /**
         * Function that returns a custom refresh interval in milliseconds.
         */
        interval: PropTypes.func.isRequired
    };


    componentDidMount() {
        this.autoRefresh = this.setupAutoRefresh()
    }


    componentWillUnmount() {
        clearInterval(this.autoRefresh)
    }


    toggleAutoRefresh(value) {
        clearInterval(this.autoRefresh)
        this.isAutoRefreshOn = value
        if (value) {
            this.autoRefresh = this.setupAutoRefresh()
        }
    }


    componentDidUpdate(prevProps, prevState) {
        if (!this.isAutoRefreshOn) {
            return
        }
        if (!this.interval || this.interval !== this.props.interval()) {
            clearInterval(this.autoRefresh)
            this.autoRefresh = this.setupAutoRefresh()
            this.interval = this.props.interval ? this.props.interval() : undefined
        }
    }


    setupAutoRefresh() {
        return setInterval(() => {
            this.props.refresh()
        }, this.props.interval())
    }


    render() {
        return (
            <div className='autoRefresh'>
                Auto Refresh &nbsp;
                <ToggleButtonGroup name='autoRefresh' type='radio' 
                                   defaultValue={true}
                                   onChange={this.toggleAutoRefresh}>
                    <ToggleButton value={true}>On</ToggleButton>
                    <ToggleButton value={false}>Off</ToggleButton>
                </ToggleButtonGroup>
            </div>
        )
    }
}
